import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mkt-confirm-dialog',
  template: `
    <div class="mkt-confirm-backdrop" *ngIf="visible" (click)="cancelled.emit()">
      <div class="mkt-confirm-card" (click)="$event.stopPropagation()">
        <h4 class="mkt-confirm-card__title">{{ title }}</h4>
        <p class="mkt-confirm-card__message">{{ message }}</p>
        <div class="mkt-confirm-card__actions">
          <button class="mkt-confirm-btn mkt-confirm-btn--cancel" (click)="cancelled.emit()">Cancel</button>
          <button class="mkt-confirm-btn" [ngClass]="'mkt-confirm-btn--' + confirmClass" (click)="confirmed.emit()">
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .mkt-confirm-backdrop {
      position: fixed;
      inset: 0;
      background: var(--mj-bg-overlay);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }
    .mkt-confirm-card {
      background: var(--mj-bg-surface);
      border-radius: 10px;
      padding: 24px;
      max-width: 400px;
      width: 90%;
      box-shadow: var(--mj-shadow-xl);
    }
    .mkt-confirm-card__title {
      margin: 0 0 8px;
      font-size: 1rem;
      font-weight: 600;
      color: var(--mj-text-primary);
    }
    .mkt-confirm-card__message {
      margin: 0 0 20px;
      font-size: 0.85rem;
      color: var(--mj-text-secondary);
      line-height: 1.5;
    }
    .mkt-confirm-card__actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
    }
    .mkt-confirm-btn {
      padding: 8px 16px;
      border: none;
      border-radius: 6px;
      font-size: 0.8rem;
      font-weight: 600;
      cursor: pointer;
      transition: opacity 0.15s;
    }
    .mkt-confirm-btn:hover { opacity: 0.9; }
    .mkt-confirm-btn--cancel {
      background: var(--mj-bg-surface-hover);
      color: var(--mj-text-primary);
    }
    .mkt-confirm-btn--danger {
      background: var(--mj-status-error);
      color: var(--mj-text-inverse);
    }
  `]
})
export class ConfirmDialogComponent {
  @Input() visible: boolean = false;
  @Input() title: string = 'Confirm';
  @Input() message: string = 'Are you sure?';
  @Input() confirmLabel: string = 'Delete';
  @Input() confirmClass: string = 'danger';
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
